import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Button,
  CircularProgress,
  Card,
  CardContent
} from '@mui/material';

import { fetchAuthSession } from '@aws-amplify/auth';


const Profile = () => {
  const navigate = useNavigate();
  const [outfitterDetails, setOutfitterDetails] = useState(null);
  const [outings, setOutings] = useState([]); // Stores outings
  const [selectedOuting, setSelectedOuting] = useState(null); // Tracks the outing being edited
  const [loading, setLoading] = useState(true);
  const [username, setUsername] = useState(null);
  const [formOpen, setFormOpen] = useState(false); // Controls whether the form is displayed


  const [chatUsername, setChatUsername] = useState('');
  const [chatUsernameLoading, setChatUsernameLoading] = useState(false);
  const [chatUsernameError, setChatUsernameError] = useState('');



  const handleChatUsernameSubmit = async () => {
    if (!chatUsername.trim()) {
      setChatUsernameError('Username cannot be empty');
      return;
    }
  
    setChatUsernameLoading(true);
    setChatUsernameError('');
  
    try {
      const session = await fetchAuthSession();
      const idToken = session?.tokens?.idToken?.toString();
  
      const response = await fetch(
        'https://c1l91zet7e.execute-api.us-east-1.amazonaws.com/prod/set-username',
        {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${idToken}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ username: chatUsername }),
        }
      );
  
      const result = await response.json();
      if (response.ok) {
        alert('Chat username updated successfully!');
      } else {
        throw new Error(result.message || 'Failed to update chat username');
      }
    } catch (err) {
      console.error('Error setting chat username:', err);
      setChatUsernameError('Failed to update chat username.');
    } finally {
      setChatUsernameLoading(false);
    }
  };

  return (
    <Box sx={{ padding: 4 }}>

    <Card sx={{ mb: 4, p: 3, boxShadow: 2 }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Set your Chat Username
        </Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>
          This name will appear in messages and group chats.
        </Typography>
        <Box display="flex" alignItems="center" gap={2}>
          <input
            type="text"
            value={chatUsername}
            onChange={(e) => setChatUsername(e.target.value)}
            placeholder="Enter chat username"
            style={{
              padding: '8px',
              borderRadius: '4px',
              border: '1px solid #ccc',
              flexGrow: 1,
            }}
          />
          <Button
            variant="contained"
            onClick={handleChatUsernameSubmit}
            disabled={chatUsernameLoading}
          >
            {chatUsernameLoading ? <CircularProgress size={20} /> : 'Save'}
          </Button>
        </Box>
        {chatUsernameError && (
          <Typography color="error" variant="body2" sx={{ mt: 1 }}>
            {chatUsernameError}
          </Typography>
        )}
      </CardContent>
    </Card>
    </Box>
 )
}

export default Profile;
